export const vFocus = {
  mounted: el => {
    el.focus()
  }
}
